import { LANDING_CONSTANTS } from '@/constants';
import aiAgeProgression from '@/public/images/landing/slider/AI_Age_Progression.webp';
import animeGenerator from '@/public/images/landing/slider/AI_Anime_Generator.webp';
import aiBabyGenerator from '@/public/images/landing/slider/AI_Baby_Generator.webp';
import aiBackgroundGenerator from '@/public/images/landing/slider/AI_Background_Generator.webp';
import bgRemover from '@/public/images/landing/slider/AI_Background_Remover.webp';
import cartoonGenerator from '@/public/images/landing/slider/AI_Cartoon_Generator.webp';
import clothesChanger from '@/public/images/landing/slider/AI_Clothes_Changer.webp';
import aiImageDetector from '@/public/images/landing/slider/AI_detector.webp';
import faceSwap from '@/public/images/landing/slider/AI_Face_swap.webp';
import generativeFill from '@/public/images/landing/slider/AI_Generative_Fill.webp';
import ghibli from '@/public/images/landing/slider/AI_Ghibli_generator.webp';
import hairStyleChanger from '@/public/images/landing/slider/AI_Hairstyle_Changer.webp';
import headshotGenerator from '@/public/images/landing/slider/AI_headshot_generator.webp';
import aiImageCombiner from '@/public/images/landing/slider/AI_Image_Combiner.webp';
import enhancer from '@/public/images/landing/slider/AI_Image_Enhancer.webp';
import imageExtender from '@/public/images/landing/slider/AI_Image_Extender.webp';
import imageGenerator from '@/public/images/landing/slider/AI_Image_Generator.webp';
import upscaler from '@/public/images/landing/slider/AI_Image_Upscaler.webp';
import lego from '@/public/images/landing/slider/AI_LEGO_generator.webp';
import logoGenerator from '@/public/images/landing/slider/AI_Logo_generator.webp';
import eraser from '@/public/images/landing/slider/AI_Magic_Eraser.webp';
import aiMusicGenerator from '@/public/images/landing/slider/AI_Music_Generator.webp';
import photoRecolor from '@/public/images/landing/slider/AI_Recolor.webp';
import aiRelight from '@/public/images/landing/slider/AI_Relight.webp';
import aiRetake from '@/public/images/landing/slider/AI_Retake.webp';
import starterPack from '@/public/images/landing/slider/AI_StarterPack_generator.webp';
import aiTattooGenerator from '@/public/images/landing/slider/AI_Tattoo_Generator.webp';
import aiVideoGenerator from '@/public/images/landing/slider/AI_Video_Generator.webp';
import aiVoiceGenerator from '@/public/images/landing/slider/AI_Voice_Generator.webp';
import watermarkRemover from '@/public/images/landing/slider/AI_Watermark_remover.webp';
import barcodeGenerator from '@/public/images/landing/slider/BARCODE.webp';
import blurImage from '@/public/images/landing/slider/Blur_Image.webp';
import colorPalette from '@/public/images/landing/slider/Color_Palette.webp';
import imageConverter from '@/public/images/landing/slider/Converter_1.webp';
import cropImage from '@/public/images/landing/slider/Croper.webp';
import englishImageIntoAnyLanguage from '@/public/images/landing/slider/English_image_into_any_language.webp';
import faceShapeDetector from '@/public/images/landing/slider/Face_Shape_Detector.webp';
import flipImage from '@/public/images/landing/slider/Flip.webp';
import fontGenerator from '@/public/images/landing/slider/Font_Generator.webp';
import imageToVideo from '@/public/images/landing/slider/Image_2_Video.webp';
import imageCompressor from '@/public/images/landing/slider/Image_compressor.webp';
import imageSplitter from '@/public/images/landing/slider/Image_Splitter.webp';
import imageToText from '@/public/images/landing/slider/Image_to_text.webp';
import passportPhotoMaker from '@/public/images/landing/slider/Passport_Photo_Maker.webp';
import photoColorizer from '@/public/images/landing/slider/Photo_Colorizer.webp';
import qrCodeGenerator from '@/public/images/landing/slider/QR_CODE_GENERATOR.webp';
import imageResizer from '@/public/images/landing/slider/Resizer.webp';
import rotateImage from '@/public/images/landing/slider/Rotate.webp';
import speechToText from '@/public/images/landing/slider/Speech_To_Text.webp';
import textToVideo from '@/public/images/landing/slider/Text_2_Video_Generator.webp';
import videoBackgroundRemover from '@/public/images/landing/slider/Video_Bg_Remover.webp';
import videoCompressor from '@/public/images/landing/slider/Video_Compressor.webp';
import videoEnhancer from '@/public/images/landing/slider/Video_Enhancer.webp';

export const exploreConfig = {
	title: 'exploreData_mainTitle',
	buttonText: 'exploreData_buttonText',
	hrefToolsPage: '/tools',
	list: [
		{
			id: 1,
			image: upscaler,
			title: 'exploreData_cards_card2',
			alt: 'exploreData_cards_card2Alt',
			href: '/image-upscaler',
		},
		{
			id: 2,
			image: enhancer,
			title: 'exploreData_cards_card3',
			alt: 'exploreData_cards_card3Alt',
			href: '/image-enhancer',
		},
		{
			id: 3,
			image: bgRemover,
			title: 'exploreData_cards_card4',
			alt: 'exploreData_cards_card4Alt',
			href: '/background-remover',
		},
		{
			id: 4,
			image: eraser,
			title: 'exploreData_cards_card5',
			alt: 'exploreData_cards_card5Alt',
			href: '/object-remover',
		},
		{
			id: 5,
			image: starterPack,
			title: 'exploreData_cards_card6',
			alt: 'exploreData_cards_card6Alt',
			href: '/ai-filters-starter-pack',
		},
		{
			id: 6,
			image: lego,
			title: 'exploreData_cards_card7',
			alt: 'exploreData_cards_card7Alt',
			href: '/ai-filters-lego',
		},
		{
			id: 7,
			image: ghibli,
			title: 'exploreData_cards_card8',
			alt: 'exploreData_cards_card8Alt',
			href: '/ai-filters-ghibli',
		},
		{
			id: 8,
			image: headshotGenerator,
			title: 'exploreData_cards_card9',
			alt: 'exploreData_cards_card9Alt',
			href: '/headshot-generator',
		},
		{
			id: 9,
			image: watermarkRemover,
			title: 'exploreData_cards_card10',
			alt: 'exploreData_cards_card10Alt',
			href: '/watermark-remover',
		},
		{
			id: 10,
			image: animeGenerator,
			title: 'exploreData_cards_card11',
			alt: 'exploreData_cards_card11Alt',
			href: '/anime-generator',
		},
		{
			id: 11,
			image: cartoonGenerator,
			title: 'exploreData_cards_card12',
			alt: 'exploreData_cards_card12Alt',
			href: '/cartoon-generator',
		},
		{
			id: 12,
			image: imageExtender,
			title: 'exploreData_cards_card13',
			alt: 'exploreData_cards_card13Alt',
			href: '/image-extender',
		},
		{
			id: 13,
			image: hairStyleChanger,
			title: 'exploreData_cards_card14',
			alt: 'exploreData_cards_card14Alt',
			href: '/hairstyle-changer',
		},
		{
			id: 14,
			image: clothesChanger,
			title: 'exploreData_cards_card15',
			alt: 'exploreData_cards_card15Alt',
			href: '/clothes-changer',
		},
		{
			id: 15,
			image: photoColorizer,
			title: 'exploreData_cards_card16',
			alt: 'exploreData_cards_card16Alt',
			href: '/photo-colorizer',
		},
		{
			id: 16,
			image: photoRecolor,
			title: 'exploreData_cards_card17',
			alt: 'exploreData_cards_card17Alt',
			href: '/photo-recolor',
		},
		{
			id: 17,
			image: generativeFill,
			title: 'exploreData_cards_card18',
			alt: 'exploreData_cards_card18Alt',
			href: '/generative-fill',
		},
		{
			id: 18,
			image: faceSwap,
			title: 'exploreData_cards_card19',
			alt: 'exploreData_cards_card19Alt',
			href: '/ai-face-swap',
		},
		{
			id: 19,
			image: aiBackgroundGenerator,
			title: 'exploreData_cards_card20',
			alt: 'exploreData_cards_card20Alt',
			href: '/ai-background',
		},
		{
			id: 20,
			image: passportPhotoMaker,
			title: 'exploreData_cards_card21',
			alt: 'exploreData_cards_card21Alt',
			href: '/passport-photo-maker',
		},
		{
			id: 21,
			image: aiTattooGenerator,
			title: 'exploreData_cards_card22',
			alt: 'exploreData_cards_card22Alt',
			href: '/ai-tattoo-generator',
		},
		{
			id: 22,
			image: logoGenerator,
			title: 'exploreData_cards_card24',
			alt: 'exploreData_cards_card24Alt',
			href: '/ai-logo-generator',
		},
		{
			id: 23,
			image: imageCompressor,
			title: 'exploreData_cards_card26',
			alt: 'exploreData_cards_card26Alt',
			href: '/image-compressor',
		},
		{
			id: 24,
			image: imageConverter,
			title: 'exploreData_cards_card27',
			alt: 'exploreData_cards_card27Alt',
			href: '/image-converter',
		},
		{
			id: 25,
			image: imageGenerator,
			title: 'exploreData_cards_card1',
			alt: 'exploreData_cards_card1Alt',
			href: '/ai-image-generator',
		},
		{
			id: 26,
			image: imageToText,
			title: 'exploreData_cards_card28',
			alt: 'exploreData_cards_card28Alt',
			href: '/image-to-text',
		},
		{
			id: 27,
			image: imageResizer,
			title: 'exploreData_cards_card29',
			alt: 'exploreData_cards_card29Alt',
			href: '/image-resizer',
		},
		{
			id: 28,
			image: cropImage,
			title: 'exploreData_cards_card30',
			alt: 'exploreData_cards_card30Alt',
			href: '/crop-image',
		},
		{
			id: 29,
			image: flipImage,
			title: 'exploreData_cards_card31',
			alt: 'exploreData_cards_card31Alt',
			href: '/flip-image',
		},
		{
			id: 30,
			image: rotateImage,
			title: 'exploreData_cards_card32',
			alt: 'exploreData_cards_card32Alt',
			href: '/rotate-image',
		},
		{
			id: 31,
			image: aiImageDetector,
			title: 'exploreData_cards_card33',
			alt: 'exploreData_cards_card33Alt',
			href: '/ai-image-detector',
		},
		{
			id: 32,
			image: englishImageIntoAnyLanguage,
			title: 'exploreData_cards_card34',
			alt: 'exploreData_cards_card34Alt',
			href: `/${LANDING_CONSTANTS.PAGE_ENGLISH_IMAGE_TRANSLATOR}`,
		},
		{
			id: 33,
			image: aiBabyGenerator,
			title: 'exploreData_cards_card35',
			alt: 'exploreData_cards_card35Alt',
			href: '/ai-baby-generator',
		},
		{
			id: 34,
			image: blurImage,
			title: 'exploreData_cards_card36',
			alt: 'exploreData_cards_card36Alt',
			href: '/blur-image',
		},
		{
			id: 35,
			image: aiAgeProgression,
			title: 'exploreData_cards_card37',
			alt: 'exploreData_cards_card37Alt',
			href: '/ai-age-progression',
		},
		{
			id: 36,
			image: imageSplitter,
			title: 'exploreData_cards_card38',
			alt: 'exploreData_cards_card38Alt',
			href: '/image-splitter',
		},
		{
			id: 37,
			image: aiImageCombiner,
			title: 'exploreData_cards_card39',
			alt: 'exploreData_cards_card39Alt',
			href: `/ai-image-combiner`,
		},
		{
			id: 38,
			image: faceShapeDetector,
			title: 'exploreData_cards_card40',
			alt: 'exploreData_cards_card40Alt',
			href: `/${LANDING_CONSTANTS.PAGE_FACE_SHAPE_DETECTOR}`,
		},
		{
			id: 40,
			image: textToVideo,
			title: 'exploreData_cards_card43',
			alt: 'exploreData_cards_card43Alt',
			href: `/${LANDING_CONSTANTS.PAGE_TEXT_TO_VIDEO}`,
		},
		{
			id: 41,
			image: imageToVideo,
			title: 'exploreData_cards_card44',
			alt: 'exploreData_cards_card44Alt',
			href: `/${LANDING_CONSTANTS.PAGE_IMAGE_TO_VIDEO}`,
		},
		{
			id: 43,
			image: fontGenerator,
			title: 'exploreData_cards_card46',
			alt: 'exploreData_cards_card46Alt',
			href: `/${LANDING_CONSTANTS.PAGE_FONT_GENERATOR}`,
		},
		{
			id: 44,
			image: colorPalette,
			title: 'exploreData_cards_card47',
			alt: 'exploreData_cards_card47Alt',
			href: `/${LANDING_CONSTANTS.PAGE_COLOR_PALETTE_FROM_IMAGE}`,
		},
		{
			id: 45,
			image: aiVideoGenerator,
			title: 'exploreData_cards_card48',
			alt: 'exploreData_cards_card48Alt',
			href: `/${LANDING_CONSTANTS.PAGE_VIDEO_CONVERTER}`,
		},
		{
			id: 46,
			image: aiRelight,
			title: 'exploreData_cards_card49',
			alt: 'exploreData_cards_card49Alt',
			href: `/${LANDING_CONSTANTS.PAGE_AI_RELIGHT}`,
		},
		{
			id: 47,
			image: aiRetake,
			title: 'exploreData_cards_card50',
			alt: 'exploreData_cards_card50Alt',
			href: `/${LANDING_CONSTANTS.PAGE_AI_RETAKE}`,
		},
		{
			id: 48,
			image: qrCodeGenerator,
			title: 'exploreData_cards_card51',
			alt: 'exploreData_cards_card51Alt',
			href: `/${LANDING_CONSTANTS.PAGE_QR_CODE_GENERATOR}`,
		},
		{
			id: 49,
			image: videoCompressor,
			title: 'exploreData_cards_card52',
			alt: 'exploreData_cards_card52Alt',
			href: `/${LANDING_CONSTANTS.PAGE_VIDEO_COMPRESSOR}`,
		},
		{
			id: 50,
			image: barcodeGenerator,
			title: 'exploreData_cards_card53',
			alt: 'exploreData_cards_card53Alt',
			href: `/${LANDING_CONSTANTS.PAGE_BARCODE_GENERATOR}`,
		},
		{
			id: 51,
			image: videoBackgroundRemover,
			title: 'exploreData_cards_card54',
			alt: 'exploreData_cards_card54Alt',
			href: `/${LANDING_CONSTANTS.PAGE_VIDEO_BACKGROUND_REMOVER}`,
		},
		{
			id: 52,
			image: videoEnhancer,
			title: 'exploreData_cards_card55',
			alt: 'exploreData_cards_card55Alt',
			href: `/${LANDING_CONSTANTS.PAGE_VIDEO_ENHANCER}`,
		},
		{
			id: 53,
			image: aiVoiceGenerator,
			title: 'exploreData_cards_card56',
			alt: 'exploreData_cards_card56Alt',
			href: `/${LANDING_CONSTANTS.PAGE_AI_VOICE_GENERATOR}`,
		},
		{
			id: 54,
			image: aiMusicGenerator,
			title: 'exploreData_cards_card57',
			alt: 'exploreData_cards_card57Alt',
			href: `/${LANDING_CONSTANTS.PAGE_AI_MUSIC_GENERATOR}`,
		},
		{
			id: 55,
			image: speechToText,
			title: 'exploreData_cards_card58',
			alt: 'exploreData_cards_card58Alt',
			href: `/${LANDING_CONSTANTS.PAGE_SPEECH_TO_TEXT}`,
		},
	],
};
